import React from 'react';
import PropTypes from "prop-types";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class Info extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {modal:false};
  }
  
  toggle () {
    const {modal} = this.state;
    this.setState({modal:!modal});
  }

  render() {
    const {
      className,
      titulo,
      mensagem,
    } = this.props;
    const { modal } = this.state;
    return (
      <div>
        <Modal isOpen={modal} toggle={()=>this.toggle()} className={className}>
          <ModalHeader toggle={()=>this.toggle()}>{titulo}</ModalHeader>
          <ModalBody>
            {mensagem}
            {this.props.children}
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={()=>this.toggle()}>Ok</Button>{' '}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

Info.propTypes = {
  titulo: PropTypes.string.isRequired,
  mensagem: PropTypes.string,
  className: PropTypes.string,
};

export default Info;